module.exports = __webpack_public_path__ + "img/intefral.952f41d4.png";